import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22582 35181"
    {...props}
  >
    <path
      d="M22582 4176v17820c0 1553-63 2868-198 3946-127 1086-428 2187-895 3296-769 1878-2045 3336-3827 4374-1783 1046-3946 1569-6498 1569-2306 0-4231-364-5768-1085-1545-729-2781-1902-3732-3526-491-864-895-1863-1205-2988C151 26449 0 25372 0 24357c0-1085 301-1909 903-2488 603-570 1379-855 2322-855 911 0 1601 261 2060 792 468 523 824 1339 1070 2456 261 1189 531 2140 792 2853 262 713 705 1323 1323 1830 618 515 1498 769 2647 769 3050 0 4572-2235 4572-6712V4176c0-1387 309-2432 919-3130C17218 349 18050 0 19104 0c1062 0 1910 349 2536 1046 626 698 942 1735 942 3130z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
